import React from "react";
import { APP_VERSION } from "../constants";

export default function Footer() {
  return (
    <footer style={{
      borderTop: '1px solid var(--surface-border)',
      padding: 'var(--spacing-lg) var(--spacing-xl)',
      marginTop: 'auto',
    }}>
      <div style={{
        maxWidth: '1600px',
        margin: '0 auto',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 'var(--spacing-md)',
        flexWrap: 'wrap',
        fontSize: 'var(--font-size-xs)',
        color: 'var(--text-muted)',
      }}>
        <span>Drumly Dashboard v{APP_VERSION}</span>
        <span style={{ opacity: 0.5 }}>•</span>
        <span>© {new Date().getFullYear()} Drumly</span>
      </div>
    </footer>
  );
}
